import React from 'react';
import { Tags } from '@leapfinance/geebee-component-library';
export var SOPStatusEnum;
(function (SOPStatusEnum) {
    SOPStatusEnum["REQUEST_INITIATED"] = "REQUEST_INITIATED";
    SOPStatusEnum["REQUEST_RAISED"] = "REQUEST_RAISED";
    SOPStatusEnum["REQUEST_ON_HOLD"] = "REQUEST_ON_HOLD";
    SOPStatusEnum["ON_HOLD_RESOLVED"] = "ON_HOLD_RESOLVED";
    SOPStatusEnum["FIRST_DRAFT_SHARED"] = "FIRST_DRAFT_SHARED";
    SOPStatusEnum["CHANGES_REQUIRED"] = "CHANGES_REQUIRED";
    SOPStatusEnum["UPDATED_SOP_SHARED"] = "UPDATED_SOP_SHARED";
    SOPStatusEnum["REQUEST_FULFILLED"] = "REQUEST_FULFILLED";
    SOPStatusEnum["REQUEST_DELETED"] = "REQUEST_DELETED";
    SOPStatusEnum["DRAFT_IN_REVIEW"] = "DRAFT_IN_REVIEW";
    SOPStatusEnum["CANNOT_BE_PROCESSED"] = "CANNOT_BE_PROCESSED";
})(SOPStatusEnum || (SOPStatusEnum = {}));
var getTagVariant = function (status) {
    var _a;
    if ((_a = [
        SOPStatusEnum.REQUEST_INITIATED,
        SOPStatusEnum.REQUEST_RAISED,
        SOPStatusEnum.ON_HOLD_RESOLVED,
        SOPStatusEnum.CHANGES_REQUIRED
    ]) === null || _a === void 0 ? void 0 : _a.includes(status)) {
        return 'warning';
    }
    if ([SOPStatusEnum.REQUEST_ON_HOLD, SOPStatusEnum.REQUEST_DELETED, SOPStatusEnum.CANNOT_BE_PROCESSED].includes(status)) {
        return 'error';
    }
    if (status === SOPStatusEnum.REQUEST_FULFILLED) {
        return 'success';
    }
    return 'primary';
};
var SOPStatusChip = function (_a) {
    var status = _a.status, statusLabel = _a.statusLabel;
    return (React.createElement(Tags, { title: statusLabel, size: "medium", hasActiveBorder: true, variant: getTagVariant(status), containerClasses: "lfc-text-center" }));
};
export default SOPStatusChip;
//# sourceMappingURL=SOPStatusChip.js.map